import { createContext } from 'react';
import Keycloak, { KeycloakTokenParsed } from 'keycloak-js';

export interface KeycloakUserInfo {
  id?: string;
  name?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  preferredUsername?: string;
  realmRoles?: string[];
  roles?: string[] | {
    realm?: string[];
    client?: string[];
  };
}

export interface KeycloakContextType {
  token: string | null;
  tokenParsed: KeycloakTokenParsed | null;
  authenticated: boolean;
  initialized: boolean;
  userInfo: KeycloakUserInfo | null;
  keycloakInstance: Keycloak | null;
  logout: () => void;
}

export const KeycloakContext = createContext<KeycloakContextType>({
  token: null,
  tokenParsed: null,
  authenticated: false,
  initialized: false,
  userInfo: null,
  keycloakInstance: null,
  logout: () => {},
});
